// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"edeeef2e","219":"ed566d6d","371":"e1d967f8","402":"b60a9103","453":"5d9d47fd"}[chunkId] + ".chunk.js";
};